import { biaInterfaceType } from "../types/index.const";

const biaInterfaceTypeOptions = biaInterfaceType.map((el) => ({
  value: el,
  label: el,
}));

export default biaInterfaceTypeOptions;
